<template>
  <div class="header-component">
    <div class="title-wrapper">
      <h1 class="title">
        <span class="layer1">{{transify['CHANGE_TITLE']}}</span>
      </h1>
      <span @click="ruleClick" class="rule-icon"></span>
      <span @click="historyClick" class="history-icon"></span>
    </div>
    <div class="userinfo">
      <div class="gem">{{gemsString}}</div>
      <div class="userid">ID:{{uid}}</div>
    </div>
  </div>
</template>
<script>
  import { mapState } from '@/utils/assist'
  import Rule from '@/components/rule/rule'
  import History from '@/components/history/history'
  import { setSessionStorage, getSessionStorage, initGA, addGA, errorGA } from '@/utils/assist'
  export default {
    data() {
      return {}
    },
    computed:{
      ...mapState(['gems', 'uid', 'transify', 'rules', 'history']),
      gemsString() {
        let number = this.$bus.gems
        let arr = String(number).split('.');
        let region = getSessionStorage(`${PROJECT_NAME}Region`) || ''
        if(region != 'IND' && region != 'BD'){
          let num = arr[0];
          let len = Math.ceil(num.length / 3) * 3;
          let result = num.padStart(len, '0').match(/\d{3}/g).join(',').replace(/^0+/, '');
          return arr[1] ? result + '.' + arr[1] : result;
        }else{
          if(number<99999){
            let num = arr[0];
            let len = Math.ceil(num.length / 3) * 3;
            let result = num.padStart(len, '0').match(/\d{3}/g).join(',').replace(/^0+/, '');
            return arr[1] ? result + '.' + arr[1] : result;
          }
          let res = []
          arr = String(number).split('');
          if(arr.length==6){
            res = [arr[0],',',arr[1],arr[2],',',arr[3],arr[4],arr[5]]
          }else if(arr.length==7){
            res = [arr[0],arr[1],',',arr[2],arr[3],',',arr[4],arr[5],arr[6]]
          }else if(arr.length==8){
            res = [arr[0],',',arr[1],arr[2],',',arr[3],arr[4],',',arr[5],arr[6],arr[7]]
          }else if(arr.length==9){
            res = [arr[0],arr[1],',',arr[2],arr[3],',',arr[4],arr[5],',',arr[6],arr[7],arr[8]]
          }else if(arr.length==10){
            res = [arr[0],',',arr[1],[2],',',arr[3],arr[4],',',arr[5],arr[6],',',arr[7],arr[8],arr[9]]
          }else if(arr.length==11){
            res = [arr[0],arr[1],',',arr[2],arr[3],',',arr[4],arr[5],',',arr[6],arr[7],',',arr[8],arr[9],arr[10]]
          }
          return res.join('')
        }
      },
    },
    methods: {
      ruleClick() {
        this.$modal.info({
          title: this.transify['CHANGE_RULE'],
          render: h =>
            h(Rule, {
              props: {
                rules: this.rules,
              },
            }),
        })
        this.$bus.addGA('showRule', 'success')
      },
      historyClick() {
        this.$modal.info({
          title: this.transify['CHANGE_HISTORY'],
          render: h =>
            h(History, {
              props: {
                history: this.history,
              },
            }),
        })
        this.$bus.addGA('showHistory', 'success')
      }
    },
  }
</script>
<style lang="scss" scoped>
  .header-component {
    position: absolute;
    top: 0;
    left: 0;
    @include px2res(height, 73);
    width: 100%;
    font-size: 0;
    z-index: 20;
    .title-wrapper {
      width: 100%;
      text-align: center;
      .title {
        display: inline-block;
        @include one-line;
        @include px2res(font-size, 46);
        .layer1 {
          @include px2res(padding, 0, 10);
          line-height: 1.7;
          color: #fff;
          // @include text-gradient(#ffffff 45%, #8b62ff 70%);
        }
      }
    }
    .rule-icon {
      position: relative;
      display: inline-block;
      @include px2res(top, 2);
      @include px2res(margin-left, 20);
      @include px2res(width, 36);
      @include px2res(height, 36);
      @include extend-click;
    }
    .history-icon {
      @extend .rule-icon;
    }
    .userinfo {
      position: absolute;
      top: 0;
      @include px2res(right, 50);
      @include px2res(height, 73);
      @include flexcc;
      align-items: flex-start;
      .gem {
        @include px2res(padding-top, 2);
        @include px2res(font-size, 36);
        color: #f1f1f1;
        @include one-line;
        &::before {
          @include gem-icon(0, 8);
          @include px2res(vertical-align, -2);
        }
      }
      .userid {
        @include px2res(padding-left, 38);
        @include px2res(font-size, 20);
        font-family: $base-font-family;
        font-style: normal;
        color: #f2f2f2;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/m-header/m-header.vue